import React from 'react';
import { IIconProps } from './utils';

export const Translate = ({
  fill = 'currentColor', height = 24, width = 24, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="2.5 0 20 24"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M22 17V7C22 4.79086 20.2091 3 18 3H12H6C3.79086 3 2 4.79086 2 7V17C2 19.2091 3.79086 21 6 21H18C20.2091 21 22
        19.2091 22 17Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M17.8486 10.0238L18.7152 10.326C18.4308 11.2804 18.063 12.1075 17.6116 12.8074C17.1603 13.5073 16.6232 14.0985
        16.0003 14.581C15.382 15.0582 14.6666 15.4479 13.8541 15.7501C13.8271 15.6652 13.7819 15.5645 13.7187
        15.4479C13.6555 15.3312 13.5901 15.2146 13.5224 15.0979C13.4592 14.9866 13.3983 14.8938 13.3396 14.8196C14.1204
        14.5757 14.8042 14.2443 15.391 13.8254C15.9777 13.4065 16.4742 12.8869 16.8804 12.2666C17.2867 11.6409 17.6094
        10.8933 17.8486 10.0238ZM15.2285 10.0874C15.4587 10.8774 15.7769 11.5853 16.1831 12.2109C16.5893 12.8366 17.0903
        13.3668 17.6861 13.8016C18.2864 14.2363 18.986 14.5598 19.7849 14.7718C19.7217 14.8461 19.6517 14.9415 19.575
        15.0582C19.5028 15.1748 19.4328 15.2914 19.3651 15.4081C19.2974 15.53 19.2432 15.6361 19.2026 15.7262C18.3586
        15.4717 17.6319 15.1006 17.0226 14.6128C16.4133 14.1197 15.8965 13.5205 15.4722 12.8154C15.0525 12.1102 14.7004
        11.2963 14.4161 10.3737L15.2285 10.0874ZM13.4615 9.5148H19.663V10.4453H13.4615V9.5148ZM16.1289
        8.25024H16.9617V10.0795H16.1289V8.25024Z"
      fill={fill}
    />
    <path
      d="M19.6631 9.51486H16.9618V8.25024H16.1289V9.51486H13.4612V10.445H14.4389C14.7193 11.3382 15.0633 12.1287 15.4722
        12.8156C15.6007 13.0292 15.739 13.2318 15.8845 13.4259C15.7272 13.5669 15.5634 13.7016 15.3904 13.8251L15.1659
        13.9789C14.6314 14.3261 14.0225 14.6066 13.3395 14.8199C13.3981 14.8941 13.4589 14.987 13.522 15.0982C13.5896
        15.2147 13.6551 15.3309 13.7182 15.4473C13.7498 15.5057 13.7775 15.5605 13.8 15.6109L13.8535 15.7501C14.5645
        15.4856 15.2015 15.1537 15.7638 14.7552L15.9999 14.5807C16.1756 14.4446 16.3435 14.2983 16.5055 14.1449C16.67
        14.3098 16.8419 14.4661 17.0227 14.6124C17.556 15.0393 18.179 15.3773 18.8921 15.6256L19.2026 15.7257C19.2432
        15.6356 19.2976 15.53 19.3652 15.4083C19.4329 15.2916 19.5028 15.1746 19.575 15.0579C19.6516 14.9415 19.7217
        14.8465 19.7848 14.7723C19.0856 14.5867 18.4625 14.3155 17.9154 13.9593L17.6857 13.8019C17.5119 13.675 17.3471
        13.5385 17.1895 13.3954C17.2744 13.2878 17.3581 13.1784 17.4381 13.0646L17.6112 12.807C18.0436 12.1365 18.3989
        11.3491 18.6781 10.445H19.6631V9.51486ZM17.7213 10.445C17.4987 11.1369 17.219 11.7442 16.88 12.2663L16.7237
        12.4945C16.6684 12.5713 16.611 12.6457 16.5527 12.7191C16.4797 12.6284 16.408 12.5364 16.3398 12.4408L16.1834
        12.2113C15.8396 11.6817 15.5588 11.0925 15.3411 10.445H17.7213ZM15.6652 10.6953C15.8554 11.1888 16.0843 11.6439
        16.3544 12.06L16.5045 12.2809C16.5195 12.302 16.5353 12.3223 16.5506 12.3432C16.5532 12.3397 16.5565 12.3369
        16.559 12.3334L16.709 12.1149C16.9781 11.7004 17.2087 11.2272 17.4035 10.6953H15.6652ZM17.1769
        9.26462H19.6631C19.7817 9.26473 19.8781 9.37686 19.8781 9.51486V10.445C19.8781 10.583 19.7817 10.6951 19.6631
        10.6953H18.8281C18.5893 11.4321 18.2988 12.0944 17.9542 12.6801L17.7832 12.9572C17.6943 13.0951 17.6007 13.2277
        17.5052 13.3575C17.6009 13.4372 17.6986 13.5154 17.8 13.5895L18.0203 13.7408C18.5472 14.0839 19.151 14.3471
        19.833 14.5282C19.9088 14.5485 19.9696 14.6147 19.9914 14.7015C20.0132 14.7886 19.9928 14.8836 19.9379
        14.9481C19.8832 15.0124 19.8192 15.0992 19.746 15.2105C19.6764 15.323 19.6087 15.4351 19.5435 15.5474C19.479
        15.6639 19.4287 15.7624 19.3924 15.8428C19.346 15.9452 19.2454 15.9973 19.1491 15.9686C18.2851 15.7081 17.5343
        15.3256 16.901 14.8187L16.8999 14.8175C16.7624 14.7061 16.6298 14.589 16.5013 14.4671C16.4532 14.5103 16.4058
        14.5548 16.3565 14.5965L16.1195 14.7894C15.562 15.2196 14.9301 15.5789 14.226 15.8685L13.9196 15.9881C13.8103
        16.0288 13.6931 15.962 13.6532 15.8367C13.6332 15.7742 13.5955 15.6902 13.5367 15.5816L13.3448 15.2374L13.3427
        15.2362C13.3134 15.1846 13.2856 15.138 13.2587 15.097L13.1811 14.9884C13.1306 14.9242 13.1122 14.834 13.1329
        14.7503C13.1538 14.6664 13.2113 14.6009 13.2839 14.5782C14.048 14.3396 14.7119 14.0168 15.2781 13.6127L15.4858
        13.4564C15.5156 13.433 15.5437 13.4072 15.5729 13.3832C15.4772 13.2457 15.384 13.1046 15.296
        12.9584V12.9572C14.9009 12.2934 14.566 11.539 14.2899 10.6953H13.4612C13.3577 10.6952 13.2716 10.6098 13.2514
        10.4963L13.2462 10.445V9.51486C13.2462 9.37686 13.3426 9.26473 13.4612 9.26462H15.9138V8.25024C15.9138 8.11217
        16.0102 8 16.1289 8H16.9618L17.0048 8.00488C17.1028 8.02814 17.1769 8.12938 17.1769 8.25024V9.26462Z"
      fill={fill}
    />
    <path
      d="M13 3L11.4287 21H4.0957C3.39729 20.1667 2 18.1 2 16.5V6C2.52381 5.00001 4.09521 3.00003 6.19043 3H13ZM7.5
        8.00098C7.35708 7.99336 7.2228 8.02829 7.09668 8.10449C6.97897 8.18074 6.88994 8.27939 6.83105 8.40137L4.04297
        15.1416C3.96726 15.34 3.99198 15.5349 4.11816 15.7256C4.2443 15.9086 4.4505 15.9999 4.73633 16C5.03066 16
        5.2367 15.8665 5.35449 15.5996L5.97363 14.1123H9.03906L9.6582 15.5996C9.76758 15.8665 9.96504 16 10.251
        16C10.5453 16 10.7557 15.9086 10.8818 15.7256C11.008 15.5349 11.0327 15.34 10.957 15.1416L8.16895
        8.40137C8.04274 8.11926 7.81957 7.98572 7.5 8.00098ZM8.52246 12.8535H6.47754L7.5 10.3926L8.52246 12.8535Z"
      fill={fill}
    />
  </svg>
);
